export const propertyAmenityKeys = {
  all: ['property-amenities'],
  list: (params: any) => ['property-amenities', 'list', params],
  detail: (id: any) => ['property-amenities', 'detail', id],
};
